<template>
  <div
    class="dlrLayer"
    v-show="showDialog"
    :class="currentClass"
    :style="{ zIndex: zindex }"
  >
    <slot></slot>
  </div>
</template>
<script>
import layerManager from '@/services/layer.manager';
export default {
  name: 'Layer',
  props: {
    layerName: {
      type: String,
      default: ''
    },
    zindex: {
      type: [Number, undefined],
      default: undefined
    },
    /**
     * 动画方向
     */
    maskDirection: {
      type: String,
      default: 'Bottom'
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showDialog: false,
      currentClass: ''
    };
  },
  created () {
    this.maskDirection && (this.currentClass = `slide${this.maskDirection}_out`);
  },
  watch: {
    visible: {
      handler: function (newVal) {
        if (!newVal) {
          this.currentClass = `slide${this.maskDirection}_out`;
          setTimeout(() => {
            this.showDialog = false;
            layerManager.close(this.layerName);
            this.$emit('closed');
          }, 350);
        } else {
          this.showDialog = true;
          setTimeout(() => { this.currentClass = `slide${this.maskDirection}_in`; }, 20);
        }
      },
      immediate: true
    }
  }
};
</script>
